'use client'; // Added to mark as a Client Component

import React from 'react';
// import { Loader2 } from 'lucide-react'; // No longer needed
import { cn } from '@/lib/utils';
import { Spinner } from '@/components/ui/spinner'; // Import the new Spinner

interface PageLoaderProps {
    className?: string;
    message?: string; // Optional loading message
    fullPage?: boolean; // Optional prop to control height
}

export default function PageLoader({
    className,
    message,
    fullPage = true,
}: PageLoaderProps) {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center text-center',
                fullPage
                    ? 'min-h-[calc(100vh-var(--header-height,8rem))]'
                    : 'py-10', // Adjust height based on prop
                className
            )}
        >
            <Spinner size={80} className="text-primary" />
            {message && (
                <p className="mt-4 text-sm text-muted-foreground">{message}</p>
            )}
        </div>
    );
}
